export const environment = {
    production: false,
    baseURL : 'https://qa.cnergycloud.net/api/',
     signalRHubUrl: 'https://Rapid-Web-QA:8090/notify',
  notificationApiUrl: 'https://Rapid-Web-QA:8090/api/Notification'
    //baseURL : 'http://10.200.24.87:8099/api/'
};
